import(/* webpackMode: "eager" */ "/vercel/path0/src/app/events/[slug]/loading.tsx");
